import {MenuList} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import {Message} from "../../lib/stores/MessageStore";
import discord_emojis from "../../../data/discord_emojis.json";
import shadowClient from "../../lib/clients/shadow/shadowClient";
import {notifier} from "../../lib/Notifier";
import Box from "../../Common/Box";
import {Emoji} from "../Emoji";

const emojis = discord_emojis;
const emojiNames = Object.keys(emojis);

interface ReactionPanelProps {
    message: Message,
    onClose: () => any,
}

export function ReactionPanel({message, onClose}: ReactionPanelProps) {

    return <MenuList
            id="composition-menu"
            aria-labelledby="composition-button"
            // onKeyDown={handleListKeyDown}
    >
        {emojiNames.slice(0, 100).map((emojiName, i) =>
                <MenuItem
                        key={i}
                        // selected={selectedIndex === i}
                        // autoFocus={selectedIndex === i}
                        // onFocus={() => {
                        //     inputRef.current.focus();
                        // }}
                        onClick={async () => {
                            // @ts-ignore
                            const emojiStr = discord_emojis[emojiName];
                            try {
                                await shadowClient.addReaction(message.room_id, message.id, emojiStr);
                            } catch (e) {
                                notifier.error("Failed to add reaction. Error: " + e.message);
                            }
                            onClose();
                        }}>

                    <Box
                            row
                            sx={{
                                alignItems: "center",
                            }}
                    >

                        <Emoji
                                size={36}
                                // @ts-ignore
                                emojiStr={discord_emojis[(emojiName)]}
                        />
                        <Box
                                sx={{
                                    marginLeft: "10px",
                                }}
                                fontWeight={500}
                        >
                            {emojiName}
                        </Box>
                    </Box>
                </MenuItem>
        )
        }
    </MenuList>
}
